import { render } from "./Registro02TC.vue?vue&type=template&id=5029b428&scoped=true"
import script from "./Registro02TC.vue?vue&type=script&lang=js"
export * from "./Registro02TC.vue?vue&type=script&lang=js"

import "@/assets/css/registro02TC.css?vue&type=style&index=0&id=5029b428&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5029b428"]])

export default __exports__